import { Injectable } from '@angular/core';

import { AssetsSharedService } from '@features/cms-render/ui/services/assets-shared/assets-shared.service';

@Injectable()
export class GenerateSrcsetService {
    constructor(
        private readonly assetsSharedService: AssetsSharedService
    ) { }

    public generateSrcset(
        imageLandscapeUrl: string,
        imagePortraitUrl: string,
        assetsUrl: string
    ): Array<{ width: number; src: string }> {
        const srcsetParts: Array<{ width: number; src: string }> = [];

        const breakpoints = [375, 768, 828, 1024, 1280, 1536, 1920, 2048, 2200, 2400, 2600, 2800, 3000];
        for (const i of breakpoints) {
            const image = i > 1024 ? imageLandscapeUrl : imagePortraitUrl;
            srcsetParts.push(
                {
                    width: i,
                    src: this.assetsSharedService
                        .getAssetUrl(image, assetsUrl, { width: i, enabled: true }),
                }
            );
        }
        return srcsetParts;
    }
}
